var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 0.625H2.4375C1.22934 0.625 0.25 1.60434 0.25 2.8125V21.1875C0.25 22.3957 1.22934 23.375 2.4375 23.375H15.5625C16.7707 23.375 17.75 22.3957 17.75 21.1875V7.625L10.75 0.625ZM9.875 8.5V2.375L16 8.5H9.875Z",
    fill: "#5CB226"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.de79b4124b929f4b997ac9d6d43dc0b6.svg";
export { ForwardRef as ReactComponent };